const Action1 = [
    {id: "-1", value: "無動作"},    
    {id: "0", value: "複製區塊"},    
    {id: "1", value: "左右相反"},   
    {id: "2", value: "上下顛倒"},
];  
  
  export default Action1